import React, { useMemo } from "react";

import InitialDataListPage from "../components/InitialDataListPage";

const WarehouseMain = ({
  masterList = [],
  name,
  onPageInsert,
  onRowSelected,
}) => {
  const columns = useMemo(
    () => [
      {
        key: "index",
        header: "#",
        width: "8%",
        align: "center",
        render: (_item, _index, { startIndex, itemIndex }) =>
          startIndex + itemIndex + 1,
      },
      {
        key: "WH_Code",
        header: "รหัสคลัง",
        width: "20%",
        align: "center",
        render: (item) => item.WH_Code || "-",
      },
      {
        key: "WH_Name",
        header: "ชื่อคลัง",
        width: "56%",
        align: "start",
        render: (item) => item.WH_Name || "-",
      },
      {
        key: "WH_Status",
        header: "สถานะ",
        width: "12%",
        align: "center",
        render: (item) =>
          item.WH_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
      },
      {
        key: "actions",
        header: "แก้ไข",
        width: "8%",
        align: "center",
        isAction: true,
        render: (item, _index, { triggerRowSelected }) => (
          <button
            onClick={(event) => {
              event.stopPropagation();
              triggerRowSelected(item);
            }}
            className="btn btn-sm"
            title="แก้ไข"
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#fff3e0",
              color: "#EF6C00",
              transition: "all 0.2s ease",
            }}
            onMouseOver={(event) => {
              event.currentTarget.style.backgroundColor = "#EF6C00";
              event.currentTarget.style.color = "#fff";
            }}
            onMouseOut={(event) => {
              event.currentTarget.style.backgroundColor = "#fff3e0";
              event.currentTarget.style.color = "#EF6C00";
            }}
            type="button"
          >
            <i className="fas fa-edit" />
          </button>
        ),
      },
    ],
    []
  );

  const getSearchValues = useMemo(
    () => (item) => [
      item?.WH_Code,
      item?.WH_Name,
      item?.WH_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
    ],
    []
  );

  return (
    <InitialDataListPage
      name={name}
      entityPath="/tbsetwh"
      data={masterList}
      onCreate={onPageInsert}
      onRowSelected={onRowSelected}
      columns={columns}
      getSearchValues={getSearchValues}
      searchPlaceholder="ค้นหาคลังสินค้า..."
      fieldMappings={{ no: "WH_Id" }}
      getRowId={(item) => item?.WH_Id}
    />
  );
};

export default WarehouseMain;
